import React, { useEffect } from 'react';
import "react-responsive-modal/styles.css";
import { Modal as ReactModal } from "react-responsive-modal";
import './modal.scss';
import usePrevious from "../usePrevious";
import { lsLoad } from "../utils";
import MaskModal from "../static/maskModal.svg";

export default function StarModal(props) {
  const {levelsCleared, finalScore} = props;
  const {isOpen} = props;
  const prevIsOpen = usePrevious(isOpen);
  const berriesCollection = lsLoad("berriesCollection");
  let berriesCollected = 0;
  if(berriesCollection) {
    berriesCollected = berriesCollection.reduce(function(a, b){
      return a + b;
    }, 0);
  }
  useEffect(() => {
    if (!prevIsOpen && isOpen) {
      props.gameOverSound.play();
    }
  });
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return (
    <ReactModal
      classNames={{
        overlay: "modal-component-overlay",
        modal: "modal-component-container",
      }}
      center
      open={props.isOpen}
      onClose={() => {}}
      showCloseIcon={false}
      closeOnOverlayClick={false}
    >
      <img alt="bg" className="maskModal" src={MaskModal} />
      {/* <div className="flex center modal-header">
        Timeout
      </div> */}
      <div className="modal-content" style={{top: isMobile ? "48%" : "38%"}}>

        <div className="flex flex-row berry-result-container">
          <img src={require("../static/timeoutBerry.svg")} alt="berry"/>
        </div>

        <div className="result-text" style={{marginBottom: '22px'}}>
          Game Over. 
          <div>Here's how you performed</div>
        </div>

        <div className="moves-details">
          <div className="mb-4">
            Levels cleared: {levelsCleared}
          </div>
          <div className="mb-4">
            Berries collected : {berriesCollected}
          </div>
          {/* <div className="mb-4">
            Final score: {finalScore}
          </div> */}
        </div>

        {/* <div className="modal-bottom-img">
          {new Array(3).fill(3).map((_, index) => <img key={index} className="modal-img-stars" src={require("../static/maskedBerries.svg")} alt="img-modal"/>)}
        </div> */}

        {props.content}
      </div>
      <span className="modal-infotext">{props.infoText}</span>
      {props.children}
    </ReactModal>
  );
}
